// Generated from grammarParser.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from "antlr4";

// This class defines a complete listener for a parse tree produced by grammarParser.
export default class grammarParserListener extends antlr4.tree
  .ParseTreeListener {
  // Enter a parse tree produced by grammarParser#compilationUnit.
  // eslint-disable-next-line no-unused-vars
  enterCompilationUnit(ctx) {}

  // Exit a parse tree produced by grammarParser#compilationUnit.
  // eslint-disable-next-line no-unused-vars
  exitCompilationUnit(ctx) {}

  // Enter a parse tree produced by grammarParser#initialSetence.
  // eslint-disable-next-line no-unused-vars
  enterInitialSetence(ctx) {}

  // Exit a parse tree produced by grammarParser#initialSetence.
  // eslint-disable-next-line no-unused-vars
  exitInitialSetence(ctx) {}

  // Enter a parse tree produced by grammarParser#setenses.
  // eslint-disable-next-line no-unused-vars
  enterSetenses(ctx) {}

  // Exit a parse tree produced by grammarParser#setenses.
  // eslint-disable-next-line no-unused-vars
  exitSetenses(ctx) {}

  // Enter a parse tree produced by grammarParser#moreSetences.
  // eslint-disable-next-line no-unused-vars
  enterMoreSetences(ctx) {}

  // Exit a parse tree produced by grammarParser#moreSetences.
  // eslint-disable-next-line no-unused-vars
  exitMoreSetences(ctx) {}
}
